var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 46.45,
    viewBox: "0 0 48 46.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12084",
    "data-name": "Group 12084",
    transform: "translate(-659.905 -857.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12080",
    "data-name": "Group 12080",
    transform: "translate(659.905 857.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171284590",
    "data-name": "Group 1171284590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12065",
    "data-name": "Group 12065",
    transform: "translate(16.118 14.569)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 15.941,
    cy: 15.941,
    rx: 15.941,
    ry: 15.941,
    fill: "#3a96df"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49598",
    "data-name": "Path 49598",
    d: "M29.248,9.821l-8.1-8.241A5.539,5.539,0,0,0,17.193.011H5.533A5.34,5.34,0,0,0,0,5.308V32.777a5.5,5.5,0,0,0,5.533,5.494H25.3a5.5,5.5,0,0,0,5.533-5.494V13.549A5.341,5.341,0,0,0,29.248,9.821ZM7.36,15.511h5.929a1.553,1.553,0,0,1,1.581,1.57,1.449,1.449,0,0,1-1.581,1.569H7.36a1.57,1.57,0,1,1,0-3.139ZM19.217,26.5H7.36a1.553,1.553,0,0,1-1.581-1.57,1.449,1.449,0,0,1,1.581-1.57H19.217a1.57,1.57,0,1,1,0,3.139Z",
    transform: "translate(0 0)",
    fill: "#ff8d00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12068",
    "data-name": "Group 12068",
    transform: "translate(16.118 14.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12066",
    "data-name": "Group 12066"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 15.941,
    cy: 15.941,
    rx: 15.941,
    ry: 15.941,
    fill: "#f5e0c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12067",
    "data-name": "Group 12067",
    transform: "translate(9.395 8.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49599",
    "data-name": "Path 49599",
    d: "M37.239,28.454l-6.358-6.361a.318.318,0,0,0-.45,0l-6.338,6.36a.318.318,0,0,0,.225.542h3.5v7.944a.318.318,0,0,0,.318.318h5.084a.318.318,0,0,0,.318-.318V29h3.482a.317.317,0,0,0,.224-.542Z",
    transform: "translate(-24 -22)",
    fill: "#ff8d00"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultUpload);
export default __webpack_public_path__ + "static/media/consultUpload.064cde272af8972b0e69c1375fc14a28.svg";
export { ForwardRef as ReactComponent };